import { render, staticRenderFns } from "./shrinkable-menu.vue?vue&type=template&id=0bb15584"
import script from "./shrinkable-menu.vue?vue&type=script&lang=ts"
export * from "./shrinkable-menu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports